import { FFmpeg } from '../http-requests';

const checkVideoProcessingStatus = async (task_id: string): Promise<any> => {
  const response = await FFmpeg.GetProcessedMedia(task_id).then((r) =>
    r.json()
  );
  if (['error', 'success'].includes(response.status)) {
    return response;
  } else {
    // Ограничение частоты опроса статуса операций над видео
    await new Promise((r) => setTimeout(r, 5000));
    return await checkVideoProcessingStatus(task_id);
  }
};

export async function processVideo(videoFile: File, setFileProcessing: Function) {
  // Отправка задачи в celery task на обработку видео
  const data = new FormData();
  data.append('data', videoFile);
  const response = await FFmpeg.CompressRequestVideo(data);
  setFileProcessing('processing');

  // Опрос готовности выполнения задачи
  const videoProcessingResponse: any = await checkVideoProcessingStatus(
    response.task_id
  );

  // По готовности в response будет file_id
  if (videoProcessingResponse.file_id) {
    // Подготовка и формирование файла видео для <VideoPlayer />
    setFileProcessing('downloading');
    const readableStream = await FFmpeg.GetProcessedMedia(response.task_id, {
      file_id: videoProcessingResponse.file_id,
    });
    const blob = await readableStream.blob();
    const fileNameFromResponseHeaders = readableStream.headers.get(
      'content-disposition'
    );

    const fileFromBlob = new File(
      [blob],
      fileNameFromResponseHeaders
        ? decodeURIComponent(
            fileNameFromResponseHeaders
              .split('filename=')[1]
              .split(';')[0]
              .replaceAll('"', '')
          )
        : '',
      { type: 'video/mp4' }
    );

    /*
      Удаление не должно блокировать дальнейшее выполнение кода, даже если
      будет ошибка, на backend этот файл помечен в очередь на удаление
      через CleanFilesTask
    */
    FFmpeg.DeleteProcessedMedia(
      response.task_id,
      videoProcessingResponse.file_id
    );

    return fileFromBlob;
  }
}
